import React, { useState } from "react";
import { useSiteStatus } from "../context/SiteStatusContext";
import { AlertTriangle, X } from "lucide-react";

export function RenovationBanner() {
  const { status } = useSiteStatus();
  const [dismissed, setDismissed] = useState(false);
  if (!status?.renovation_notice || dismissed) return null;
  return (
    <div data-testid="renovation-banner" className="bg-gold text-navy px-4 py-2.5 flex items-center justify-center gap-3 text-sm font-medium relative">
      <AlertTriangle size={16} className="shrink-0" />
      <span className="text-center">Our site is currently undergoing improvements. Some features may be temporarily unavailable — thank you for your patience.</span>
      <button onClick={() => setDismissed(true)} data-testid="dismiss-renovation-banner" className="absolute right-3 hover:opacity-70" aria-label="Dismiss">
        <X size={16} />
      </button>
    </div>
  );
}
